// extracted by mini-css-extract-plugin
export default {"root":"TableActionsMenu_root__V9e3P","btnAction":"TableActionsMenu_btnAction__nKDq6","icon":"TableActionsMenu_icon__uTUUm"};